module.exports = __webpack_public_path__ + "img/loading.659e6ad3.gif";